import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

import * as types from './mutation-types';

export function fetchQuestionPage({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/question_page`, { params })
    .then(res => dispatch('setQuestionPage', res.data))
    .catch(err => Promise.reject(err.respoonse));
}

export function setQuestionPage({ commit }, data) {
  commit(types.SET_QUESTION_PAGE, data);

  return Promise.resolve(data);
}
